const setUpMixins = (app, vuetify) => {
  app.mixin({
    computed: {
      $smallScreen() {
        return vuetify.display.smAndDown.value
      }
    }
  })
}

export default setUpMixins
